export const isValidBookmapContent = (ditaText) => {
  if (!ditaText || typeof ditaText !== "string") {
    return false;
  }

  try {
    const parser = new DOMParser();
    const xml = parser.parseFromString(ditaText, "text/xml");
    const parseError = xml.querySelector("parsererror");

    return !parseError && Boolean(xml.querySelector("bookmap"));
  } catch {
    return false;
  }
};
